const ctiRequest = {};

ctiRequest["LOGIN"] = {
  transaction_id: "CTI_LOGIN",
  agent_id: "",
  agent_pass: "",
  agent_ext: "",
  session_flag: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["LDAP_AGENT_LOGIN"] = {
  transaction_id: "LDAP_AGENT_LOGIN",
  ldap_user: "",
  ldap_password: "",
  agent_ext: "",
  session_flag: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["LOGIN_UPDATE"] = {
  transaction_id: "CTI_LOGIN_UPDATE",
  agent_id: "",
  agent_pass: "",
  agent_ext: "",
  session_flag: "",
  ip: window.clientIP,
  resFormat: "1",
};

// Reset Password
ctiRequest["VALIDATE_AGENT"] = {
  transaction_id: "CTI_VALIDATE_AGENT",
  agent_id: "",
  resFormat: "1",
};

ctiRequest["CHANGE_AGENT_PASSWORD"] = {
  transaction_id: "CTI_CHANGE_AGENT_PASSWORD",
  agent_id: "",
  current_password: "",
  new_password: "",
  confirm_password: "",
 resFormat: "1",
}

ctiRequest["LOGOUT"] = {
  transaction_id: "CTI_LOGOUT",
  agent_id: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_AGENT_CONFIG"] = {
  transaction_id: "CTI_AGENT_CONFIG",
  agent_id: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_AGENT_NOTES"] = {
  transaction_id: "CTI_AGENT_NOTES",
  agent_id: "",
  notes: "",
  save: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_CHECK_AGENT_STATE"] = {
  transaction_id: "CTI_CHECK_AGENT_STATE",
  agent_id: "",
  ip: window.clientIP,
  resFormat: "1",
};
ctiRequest["CTI_LOGIN_INFO"] = {
  transaction_id: "CTI_LOGIN_INFO",
  agent_id: "",
  resFormat: "1",
};


ctiRequest["CTI_READY"] = {
  transaction_id: "CTI_READY",
  agent_id: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_AGENT_NOTIFICATION"] = {
  transaction_id: "CTI_AGENT_NOTIFICATION",
  agent_id: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_AGENT_MODE"] = {
  transaction_id: "CTI_AGENT_MODE",
  agent_id: "",
  mode: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["QUEUE_LIVE_AGENT_LIST"] = {
  transaction_id: "CTI_QUEUE_LIVE_AGENT_LIST",
  agent_id: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_AGENT_CALL_INFO"] = {
  transaction_id: "CTI_AGENT_CALL_INFO",
  agent_id: "",
  start_date: "",
  end_date: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_AGENT_LEAD_INFO"] = {
  transaction_id: "CTI_AGENT_LEAD_INFO",
  agent_id: "",
  dialer_type: "",
  lead_type: "",
  input_value: "",
  date_range: "",
  input_type: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_BREAK_REASON"] = {
  transaction_id: "CTI_BREAK_REASON",
  agent_id: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_PAUSE"] = {
  transaction_id: "CTI_PAUSE",
  agent_id: "",
  state: "",
  reason: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_DIAL"] = {
  transaction_id: "CTI_DIAL",
  agent_id: "",
  phone_num: "",
  lead_id: "",
  list_id: "",
  redialFlag: "",
  phone_type: "",
  gateway_name: "",
  callerid: "",
  uniqueid: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_DISCONNECT"] = {
  transaction_id: "CTI_DISCONNECT",
  agent_id: "",
  isFeedback: "",
  dialer_disp: "answered",
  iscustomerStrict: "",
  auto_wrapped: "",
  session_info: "",
  skip_mendate: "",
  backToIVR: 0,
  back_to_ivr_type: "",
  next_action: "",
  ph_type: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_DISCONNECT_TEL"] = {
  transaction_id: "CTI_DISCONNECT_TEL",
  agent_id: "",
  ip: window.clientIP,
  isFeedback: "",
  resFormat: "1",
};

ctiRequest["CTI_HOLD"] = {
  transaction_id: "CTI_HOLD",
  agent_id: "",
  state: "",
  ip: window.clientIP,
  resFormat: "1",
};

//Agent Transfer
ctiRequest["CTI_TRANSFERABLE_AGENT"] = {
  transaction_id: "CTI_ONLINE_AGENTS_NAME",
  agent_id: "",
  campaign_name: "",
  skill_id: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_TRANSFERABLE_CAMPAIGNS"] = {
  transaction_id: "CTI_TRANSFERABLE_CAMPAIGNS",
  agent_id: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_GET_EXTENSION"] = {
  transaction_id: "CTI_GET_EXTENSION",
  agent_id: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_GET_CAMPAIGN_SKILLS"] = {
  transaction_id: "CTI_GET_CAMPAIGN_SKILLS",
  agent_id: "",
  campaign_name: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_TRANSFER_AGENT"] = {
  transaction_id: "CTI_TRANSFER_AGENT",
  agent_id: "",
  transfer_to: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_TRANSFER_CAMPAIGN"] = {
  transaction_id: "CTI_TRANSFER_CAMPAIGN",
  agent_id: "",
  transfer_campaign_name: "",
  skill_transfer_flag: "",
  skill: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_TRANSFER_EXTENSION"] = {
  transaction_id: "CTI_TRANSFER_EXTENSION",
  agent_id: "",
  extension_id: "",
  ip: window.clientIP,
  resFormat: "1",
};

//Agent Conference
ctiRequest["CTI_CHECK_CONF_STAT"] = {
  transaction_id: "CTI_CHECK_CONF_STAT",
  agent_id: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_ONLINE_AGENTS_NAME"] ={
  transaction_id: "CTI_ONLINE_AGENTS_NAME",
  agent_id: "",
  campaign_name:"",
  ip: window.clientIP,
  resFormat: "1",
}

ctiRequest["CTI_CONFERENCE_DIAL"] = {
  transaction_id: "CTI_CONFERENCE_DIAL",
  agent_id: "",
  ip: window.clientIP,
  phone_no: "",
  dialType: "",
  vdn_select: "",
  resFormat: "1",
};

ctiRequest["CTI_CONFERENCE_DIRECT_DIAL"] = {
  transaction_id: "CTI_CONFERENCE_DIRECT_DIAL",
  agent_id: "",
  ip: window.clientIP,
  phone_no: "",
  conf_room: "",
  dialType: "",
  vdn_select: "",
  resFormat: "1",
};

ctiRequest["CTI_JOIN_CONFERENCE"] = {
  transaction_id: "CTI_JOIN_CONFERENCE",
  agent_id: "",
  ip: window.clientIP,
  cond: "",
  conf_room: "",
  exten: "",
  resFormat: "1",
};

ctiRequest["CTI_CONFERENCE_TRANSFER"] = {
  transaction_id: "CTI_CONFERENCE_TRANSFER",
  agent_id: "",
  ip: window.clientIP,
  phone_no: "",
  conf_room: "",
  resFormat: "1",
 is_parked_call: "",
 call_park_id: "",
};

ctiRequest["CTI_CONF_LOGIN"] = {
  transaction_id: "CTI_CONF_LOGIN",
  agent_id: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_CONF_BACK_TO_AGENT"] = {
  transaction_id: "CTI_CONF_BACK_TO_AGENT",
  agent_id: "",
  ip: window.clientIP,
  channel: "",
  resFormat: "1",
};

ctiRequest["CTI_CONF_MUTE"] = {
  transaction_id: "CTI_CONF_MUTE",
  agent_id: "",
  ip: window.clientIP,
  channel: "",
  confno: "",
  mute: "",
  conf_fd: "",
  ztc_chan: "",
  ztc_confno: "",
  resFormat: "1",
};

ctiRequest["CTI_JOIN_CONFERENCE_ALL"] = {
  transaction_id: "CTI_JOIN_CONFERENCE_ALL",
  agent_id: "",
  ip: window.clientIP,
  phone_num: "",
  resFormat: "1",
};

ctiRequest["CTI_SEND_DTMF"] = {
  transaction_id: "CTI_SEND_DTMF",
  agent_id: "",
  ip: window.clientIP,
  digit: "",
  channel: "",
  conf_flag: "",
  resFormat: "1",
};

ctiRequest["CTI_CONF_DISCONNECT"] = {
  transaction_id: "CTI_CONF_DISCONNECT",
  agent_id: "",
  ip: window.clientIP,
  channel: "",
  resFormat: "1",
};

ctiRequest["CTI_CALL_PARK"] = {
  transaction_id: "CTI_CALL_PARK",
  agent_id: "",
  ip: window.clientIP,
  phone: "",
  resFormat: "3",
};

ctiRequest["CTI_CALL_PARK_STATUS"] = {
  transaction_id: "CTI_CALL_PARK_STATUS",
  agent_id: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_CALL_UNPARK"] = {
  transaction_id: "CTI_CALL_UNPARK",
  agent_id: "",
  ip: window.clientIP,
  call_park_id: "",
  conf_transfer: "",
  conf_room: "",
  resFormat: "1",
};

ctiRequest["CTI_LEAD_COMMENTS_HISTORY"] = {
  transaction_id: "CTI_LEAD_COMMENTS_HISTORY",
  agent_id: "",
  ip: window.clientIP,
  lead_id: "",
  resFormat: "1",
};

//Agent CRM
ctiRequest["CTI_ADD_CUSTOMER"] = {
  transaction_id: "CTI_ADD_CUSTOMER",
  agent_id: "",
  phone_num: "",
  ip: window.clientIP,
  list_id: "",
  call_type: "",
  campaign_id: "",
  resFormat: "1",
};

ctiRequest["CTI_GET_CUST_FIELDS"] = {
  transaction_id: "CTI_GET_CUST_FIELDS",
  agent_id: "",
  list_id: "",
  campaign_id: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_CRM_UPDATE"] = {
  transaction_id: "CTI_CRM_UPDATE",
  agent_id: "",
  changed_phone_field: {},
  ip: window.clientIP,
  lead_id: "",
  campaign_id: "",
  resFormat: "1",
};

// Call Disposition
ctiRequest["CTI_GET_DISPOSITION"] = {
  transaction_id: "CTI_GET_DISPOSITION",
  agent_id: "",
  ip: window.clientIP,
  resFormat: "1",
};

ctiRequest["CTI_SET_DISPOSITION"] = {
  transaction_id: "CTI_SET_DISPOSITION",
  agent_id: "",
  ip: window.clientIP,
  cust_disp: "",
  category: "",
  next_call_time: "",
  remarks: "",
  conf_lead_id: "0",
  resFormat: "1",
};

ctiRequest["CTI_MANUAL_DIAL_LEAD_INFO"] = {
transaction_id: "CTI_MANUAL_DIAL_LEAD_INFO",
  agent_id: "",
  pnone_no: "",
  resFormat: "1",
}

// Call History
ctiRequest["CTI_AGENT_CALL_HISTORY"] = {
  transaction_id: "CTI_AGENT_CALL_HISTORY",
  agent_id: "",
  resFormat: "1",
}

ctiRequest["CALL_HISTORY_BY_AGENT"] ={
  transaction_id: "CALL_HISTORY_BY_AGENT",
  agent_id: "",
  resFormat: "1",
  datetime: "",
  limit: "0",
  call_disposition: "",
}

// Dial With Unique ID
ctiRequest["CTI_DIAL_THROUGH_UNIQUE_IDCTI_DIAL"] = {
  transaction_id: "CTI_DIAL_THROUGH_UNIQUE_ID",
  dial_through:"APIDIAL",
  agent_id: "",
  phone_num: "",
  lead_id: "",
  list_id: "",
  redialFlag: "",
  phone_type: "",
  gateway_name: "",
  callerid: "",
  ip: window.clientIP,
  resFormat: "1",
};

export default ctiRequest;

/*
  CTI_DISCONNECT_CRM: {transaction_id: 'CTI_DISCONNECT_CRM', agent_id: '', ip: window.clientIP, resFormat: '1'},
  SWITCH_TO_AUTO_PREVIEW: {transaction_id: 'CTI_AGENT_MODE', agent_id: '', ip: window.clientIP, mode: 'AUTO_PREVEIW_ENABLE', resFormat: '1'},
  SWITCH_FROM_AUTO_PREVIEW: {transaction_id: 'CTI_AGENT_MODE', agent_id: '', ip: window.clientIP, mode: 'AUTO_PREVEIW_DISABLE', resFormat: '1'},
  IVR_PATH: {transaction_id: 'CTI_IVR_PATH', agent_id: '', ip: window.clientIP, resFormat: '1'},
  CTI_SCREEN_REC: {transaction_id: 'CTI_SCREEN_REC', agent_id: '', ip: window.clientIP, resFormat: '1'},
  CTI_GET_REMARKS: {transaction_id: 'CTI_GET_REMARKS', agent_id: '', ip: window.clientIP, campaign_id: '', lead_id: '', resFormat: '1'},
  CTI_PREVIEW_LEADS: {transaction_id: 'CTI_PREVIEW_LEADS', agent_id: '', ip: window.clientIP, no_of_leads: '20', resFormat: '1'},
};*/
